import { render, staticRenderFns } from "./build_home_3_call_button_dashboard.vue?vue&type=template&id=43e8ffb4&scoped=true"
import script from "./build_home_3_call_button_dashboard.vue?vue&type=script&lang=js"
export * from "./build_home_3_call_button_dashboard.vue?vue&type=script&lang=js"
import style0 from "./build_home_3_call_button_dashboard.vue?vue&type=style&index=0&id=43e8ffb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e8ffb4",
  null
  
)

export default component.exports